const map = {
	"./apple-touch-icon.png": 54593,
	"./browserconfig.xml": 99381,
	"./favicon-16x16.png": 3584,
	"./favicon-192x192.png": 16090,
	"./favicon-32x32.png": 35068,
	"./favicon.ico": 78043,
	"./icon.png": 91202,
	"./icon_192x192.png": 91391,
	"./mstile-150x150.png": 51666,
	"./safari-pinned-tab.svg": 5314
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25547;